document.addEventListener("DOMContentLoaded", () => {
	const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	const marks = document.querySelectorAll(".hero-home h1 mark");

	if (marks.length && !prefersReducedMotion) {
		import("../../../assets/js/gsap.js").then(({ gsap }) => {
			marks.forEach((mark) => {
				gsap.set(mark, { "--mark-reveal": "100%" });
				gsap.to(mark, {
					"--mark-reveal": "0%",
					duration: 0.6,
					delay: 0.35,
					ease: "power4.in",
				});
			});
		});
	}
});

import("../../../assets/js/splide.js")
	.then(({ Splide, AutoScroll }) => {
		// Variables
		const sliders = document.querySelectorAll(".hero-home .splide")

		// Initializing Splider
		for (let i = 0; i < sliders.length; i++) {
			new Splide(sliders[i], {
				type: "loop",
				height: '490px',
				gap: "42px",
                arrows: false,
				pagination: false,
				autoWidth: true,
				autoScroll: {
					speed: .7,
					pauseOnFocus: false,
					pauseOnHover: false,
				},
                breakpoints: {
                    1023: {
						height: '320px',
						gap: "2rem",
						autoScroll: {
							speed: 0.85
						},
                    },
                    767: {
						height: '300px',
                        gap: "1.5rem"
                    },
                }
			}).mount({ AutoScroll });
		}
	})
	.catch((err) => {
		console.error(err);
	});